/**
 * List of meta attributes used to search tags
 * @type {String[]}
 */
export const META_TAGS_SELECTOR_PROPERTIES = [
    'name',
    'property'
];
